import { Capacitor, SystemBars, SystemBarsStyle } from '@capacitor/core';
import { Backdrop, CircularProgress, createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import { theme as appTheme } from 'assets/theme';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { ToastContainer } from 'react-toastify';
import UpgradeRequiredModal from 'components/login/UpgradeRequiredModal';
import { appStore } from 'stores/appStore';
import AppRouter from './rooting/AppRouter';

const App = observer(() => {
	const theme = useMemo(() => createTheme(appTheme), []);

	useEffect(() => {
		if (!Capacitor.isNativePlatform()) return;

		void SystemBars.setStyle({ style: SystemBarsStyle.Light }).catch(() => undefined);
	}, []);

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline>
				<Backdrop open={appStore.isLoading} sx={(theme) => ({ zIndex: theme.zIndex.tooltip + 1 })}>
					<CircularProgress color='inherit' />
				</Backdrop>
				<ToastContainer />
				<AppRouter />
				<UpgradeRequiredModal />
			</CssBaseline>
		</ThemeProvider>
	);
});

export default App;
